import styled from 'styled-components';

const DetailedWrapper = styled.div`
  padding-right: 12px;
  width: 50%;
  display: flex;
  margin-left: 16px;
`;

export { DetailedWrapper };
